import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { AlertTriangle, Sparkles, Megaphone, Scale } from 'lucide-react';

const SectionList = ({ title, items, Icon, accent }) => {
  const list = Array.isArray(items) ? items : [];
  return (
    <Card>
      <CardHeader className="pb-3">
        <CardTitle className="text-base flex items-center gap-2">
          <span className={`w-8 h-8 rounded-lg ${accent} text-white flex items-center justify-center`}>
            <Icon className="w-4 h-4" />
          </span>
          {title}
        </CardTitle>
      </CardHeader>
      <CardContent>
        <ul className="space-y-2">
          {list.map((item, idx) => (
            <li key={idx} className="text-sm text-gray-700 flex gap-2">
              <span className="text-[#72BF44] mt-0.5">▸</span>
              <span>{item}</span>
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};

export const PatternsLists = ({ patterns }) => {
  const rp = patterns || {};
  return (
    <div data-testid="patterns-lists">
      <div className="grid md:grid-cols-2 gap-4 mb-6">
        <SectionList
          title="Recurring Youth Barriers"
          items={rp.youth_barriers}
          Icon={AlertTriangle}
          accent="bg-red-600"
        />
        <SectionList
          title="Recurring Opportunities"
          items={rp.recurring_opportunities}
          Icon={Sparkles}
          accent="bg-[#72BF44]"
        />
      </div>
      <div className="grid md:grid-cols-2 gap-4 mb-6">
        <SectionList
          title="Strongest Mobilisation Narratives"
          items={rp.strongest_mobilisation_narratives}
          Icon={Megaphone}
          accent="bg-[#07743F]"
        />
        <SectionList
          title="Policy Signals"
          items={rp.policy_signals}
          Icon={Scale}
          accent="bg-blue-700"
        />
      </div>
    </div>
  );
};

export default PatternsLists;
